import { CUSTOM_SCHEDULES_FAIL, CUSTOM_SCHEDULES_REQUEST, CUSTOM_SCHEDULES_RESET, CUSTOM_SCHEDULES_SUCCESS, SCHEDULES_FAIL, SCHEDULES_REQUEST, SCHEDULES_RESET, SCHEDULES_SUCCESS } from "../../constants/ScheduleConstants";

export const schedulesReducer = (state = { schedules: [] }, action) => {
    switch (action.type) {
      case SCHEDULES_REQUEST:
        return { loading: true };
      case SCHEDULES_SUCCESS:
        return { loading: false, schedules: action.payload };
      case SCHEDULES_FAIL:
        return { loading: false, error: action.payload };
      case SCHEDULES_RESET:
        return { schedules: [] };
      default:
        return state;
    }
  };


  const initialState = {
    customSchedules: [],
    loading: false,
    error: null,
  };
  
  export const customSchedulesReducer = (state = initialState, action) => {
    switch (action.type) {
      case CUSTOM_SCHEDULES_REQUEST:
        return { ...state, loading: true };
      case CUSTOM_SCHEDULES_SUCCESS:
        return { ...state, loading: false, customSchedules: action.payload };
      case CUSTOM_SCHEDULES_FAIL:
        return { ...state, loading: false, error: action.payload };
      case CUSTOM_SCHEDULES_RESET:
        return { ...state, customSchedules: [] };
      default:
        return state;
    }
  };